import React, { useEffect, useState } from "react";
import { useHistory, Link } from 'react-router-dom';
import styles from "../../assets/containers/blockPage.module.css";
import Header from "../../components/@header/header";
import LessonCard from "./lessonCard";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import { getBookProgress } from "../../service/service";
import { getAllUserIds } from "../../helpers/user";

const EMPTY_BOOK_PROGRESS = {
  isLoaded: false,
  book: null,
  batchesById: {},
  lessonsById: {},
};

const BlockPage = props => {

  const { batch } = props.location;
  const {isEmbedMode, fireNavigationEvents, setBatchData} = useAppGlobalConfig();

  const history = useHistory();
  let lessons = JSON.parse(localStorage.getItem('lessons'));
  let blockName = localStorage.getItem('blockName');
  const [bookProgress, setBookProgress] = useState(EMPTY_BOOK_PROGRESS);

  useEffect(() => {

    if (!lessons || lessons.length === 0) {
      history.push(`${isEmbedMode?'/embeddable/home':'/classes/list'}`);
    }
  }, [lessons, history]);

  useEffect(() => {
    fireNavigationEvents(`/embeddable/lessonsList`, blockName);
    setBatchData(batch);
  }, []);

  useEffect(() => {
    if (!lessons || !lessons.length) return;

    // ARTFRAN-15305: fetch consolidated progress once for the whole batch to avoid one /usage/ 404 per lesson.
    const rawBookId = localStorage.getItem("currentBookId");
    const bookId = rawBookId ? JSON.parse(rawBookId) : null;
    if (!bookId) {
      setBookProgress({ ...EMPTY_BOOK_PROGRESS, isLoaded: true });
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const tenant = isEmbedMode ? "cupheadless" : "cupfranchise";
        const ids = await getAllUserIds();
        const [primary, ...fallbackIds] = ids || [];
        if (!primary) {
          if (!cancelled) setBookProgress({ ...EMPTY_BOOK_PROGRESS, isLoaded: true });
          return;
        }

        const lessonIds = lessons.map((l) => l && l.id).filter(Boolean);
        const res = await getBookProgress(tenant, bookId, {
          userId: primary,
          userIds: fallbackIds.join(","),
          lessonIds: lessonIds.join(","),
        });
        if (cancelled) return;

        const payload = (res && res.data) || {};
        const lessonsById = {};
        (payload.lessons || []).forEach((l) => {
          if (l && l.lessonId !== undefined) lessonsById[l.lessonId] = l;
        });
        const batchesById = {};
        (payload.batches || []).forEach((b) => {
          if (b && b.batchId !== undefined) batchesById[b.batchId] = b;
        });

        setBookProgress({
          isLoaded: true,
          book: payload.book || null,
          batchesById,
          lessonsById,
        });
      } catch (err) {
        console.warn("Consolidated block progress unavailable:", err && err.message);
        if (!cancelled) setBookProgress({ ...EMPTY_BOOK_PROGRESS, isLoaded: true });
      }
    })();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmbedMode]);

  return (
    lessons && lessons.length > 0 &&
    <div className={!isEmbedMode ? `background-image` : ''} style={{minHeight: "calc(100vh - 6rem)"}} >

      {!isEmbedMode && (
          <div>
            <Header menuLanguage={true}/>
          </div>
      )}

      <div className={ !isEmbedMode ? styles["content-container"] : ''} >

        {!isEmbedMode && (
          <div className={styles["breadcrumb"]}>
            <Link to="/classes/list">Home</Link>
            <Link to="/lessonsList">Lessons</Link>
          </div>
        )}

        <div className={styles["block-container"]} >
          {
            lessons.map((lesson, groupIndex) => (
              <LessonCard key={groupIndex} lesson={lesson} groupIndex={groupIndex} bookProgress={bookProgress}/>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default BlockPage;
